module.exports = __webpack_public_path__ + "img/workspace2.dea36a13.png";